import React, { Component } from "react";
import {
  Button,
  Container,
  Row, Form,
  Col,
  Offcanvas,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from '../config.json';
import { ValidationUtils } from '../Sidebar/Common';

import LoadingOverlay from "./LoadingOverlay";
export default class Chatbotintents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      touched: {}, // Track which fields have been touched
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.chatbotintents_Id,
          sortable: true,
          cell: (row) => <span>{row.chatbotintents_Id}</span>,
        },
        { name: "Intent Name", selector: (row, i) => row.intent_name, sortable: true, cell: (row) => <span>{row.intent_name}</span>, }, { name: "Intent Description", selector: (row, i) => row.intent_description, sortable: true, cell: (row) => <span>{row.intent_description}</span>, }, { name: "Training Phrases", selector: (row, i) => row.training_phrases, sortable: true, cell: (row) => <span>{row.training_phrases}</span>, }, { name: "Response Templates", selector: (row, i) => row.response_templates, sortable: true, cell: (row) => <span>{row.response_templates}</span>, }, { name: "Required Parameters", selector: (row, i) => row.required_parameters, sortable: true, cell: (row) => <span>{row.required_parameters}</span>, }, { name: "Action Type", selector: (row, i) => row.action_type, sortable: true, cell: (row) => <span>{row.action_type}</span>, }, { name: "Target Page", selector: (row, i) => row.target_page, sortable: true, cell: (row) => <span>{row.target_page}</span>, }, { name: "Api Endpoint", selector: (row, i) => row.api_endpoint, sortable: true, cell: (row) => <span>{row.api_endpoint}</span>, }, { name: "Requires Authentication", selector: (row, i) => row.requires_authentication, sortable: true, cell: (row) => <span>{row.requires_authentication}</span>, }, { name: "Confidence Threshold", selector: (row, i) => row.confidence_threshold, sortable: true, cell: (row) => <span>{row.confidence_threshold}</span>, }, { name: "Usage Count", selector: (row, i) => row.usage_count, sortable: true, cell: (row) => <span>{row.usage_count}</span>, }, { name: "Success Rate", selector: (row, i) => row.success_rate, sortable: true, cell: (row) => <span>{row.success_rate}</span>, },
        //***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.ChatbotintentseditHandler(row)}
                className="bi bi-pen"
              >
              </Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              >
              </Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      chatbotintents_Id: "",
      intent_name: '', intent_description: '', training_phrases: '', response_templates: '', required_parameters: '', chatbotactiontypemaster: [], action_type: '', target_page: '', api_endpoint: '', requires_authentication: '', confidence_threshold: '', usage_count: '', success_rate: '',
      //***state
    };
  }

  // Enhanced validation method using Common.js with auto-generated logic
  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;
    const fieldDisplayName = fieldConfig.displayName || fieldName;

    let validationResult = { isValid: true, message: "" };

    // Auto-generated validation based on inputType and validationOptions
    switch (inputType.toLowerCase()) {
      case 'text':
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(value, parseInt(validationOptions.maxLength), fieldDisplayName);
        } else {
          validationResult = { isValid: true, message: "" };
        }
        break;

      case 'mail':
      case 'email':
        validationResult = ValidationUtils.validateEmail(value);
        break;

      case 'telephone':
      case 'phone':
        validationResult = ValidationUtils.validatePhone(value);
        break;

      case 'number':
        validationResult = ValidationUtils.validateNumber(value, fieldDisplayName);
        break;

      case 'dob_child':
        validationResult = ValidationUtils.validateDOBMinAge(value);
        break;

      case 'dob_adult':
        validationResult = ValidationUtils.validateDOBAdult(value);
        break;

      case 'pan':
        validationResult = ValidationUtils.validatePAN(value);
        break;

      case 'aadhaar':
        validationResult = ValidationUtils.validateAadhaar(value);
        break;

      case 'password':
        if (value.length < 6) {
          validationResult = { isValid: false, message: "Password must be at least 6 characters long" };
        }
        break;

      default:
        validationResult = { isValid: true, message: "" };
    }

    // Check required field validation
    if (validationOptions?.isRequired && (!value || value.toString().trim() === "")) {
      validationResult = ValidationUtils.validateRequired(value, fieldDisplayName);
    }

    const errors = { ...this.state.errors };
    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }

    this.setState({ errors });
    return validationResult.isValid;
  };

  // Enhanced field change handler with auto-validation
  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({
      [fieldName]: value,
      touched: { ...this.state.touched, [fieldName]: true }
    });

    // Only validate if field has been touched
    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  // Enhanced field blur handler for validation
  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true }
    });
    this.validateField(fieldName, value, fieldConfig);
  };

  // Check if form is valid - auto-generated based on required fields
  isFormValid = () => {
    const { errors } = this.state;

    // Auto-generated required field validation
    // No required fields defined


    return Object.keys(errors).length === 0;
  };

  // Auto-generated validation for all fields before submission
  validateAllFields = () => {
    const fieldConfigs = [
      { fieldName: 'intent_name', inputType: 'Text', displayName: 'Intent Name', validationOptions: { isRequired: false } },
      { fieldName: 'intent_description', inputType: 'Text', displayName: 'Intent Description', validationOptions: { isRequired: false } },
      { fieldName: 'training_phrases', inputType: 'Text', displayName: 'Training Phrases', validationOptions: { isRequired: false } },
      { fieldName: 'response_templates', inputType: 'Text', displayName: 'Response Templates', validationOptions: { isRequired: false } },
      { fieldName: 'required_parameters', inputType: 'Text', displayName: 'Required Parameters', validationOptions: { isRequired: false } },
      { fieldName: 'action_type', inputType: 'Select', displayName: 'Action Type', validationOptions: { isRequired: false } },
      { fieldName: 'target_page', inputType: 'Text', displayName: 'Target Page', validationOptions: { isRequired: false } },
      { fieldName: 'api_endpoint', inputType: 'Text', displayName: 'Api Endpoint', validationOptions: { isRequired: false } },
      { fieldName: 'requires_authentication', inputType: 'Number', displayName: 'Requires Authentication', validationOptions: { isRequired: false } },
      { fieldName: 'confidence_threshold', inputType: 'Text', displayName: 'Confidence Threshold', validationOptions: { isRequired: false } },
      { fieldName: 'usage_count', inputType: 'Number', displayName: 'Usage Count', validationOptions: { isRequired: false } },
      { fieldName: 'success_rate', inputType: 'Text', displayName: 'Success Rate', validationOptions: { isRequired: false } }
    ];

    fieldConfigs.forEach(config => {
      const value = this.state[config.fieldName];
      this.validateField(config.fieldName, value, config);
    });

    const touched = {};
    fieldConfigs.forEach(config => {
      touched[config.fieldName] = true;
    });
    this.setState({ touched });

  };

  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      errors: {},
      touched: {},
      intent_name: '', intent_description: '', training_phrases: '', response_templates: '', required_parameters: '', chatbotactiontypemaster: [], action_type: '', target_page: '', api_endpoint: '', requires_authentication: '', confidence_threshold: '', usage_count: '', success_rate: '',
    });
  };

  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      errors: {},
      touched: {},
      intent_name: '', intent_description: '', training_phrases: '', response_templates: '', required_parameters: '', chatbotactiontypemaster: [], action_type: '', target_page: '', api_endpoint: '', requires_authentication: '', confidence_threshold: '', usage_count: '', success_rate: '',
    });
  };

  // Enhanced toast notifications
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };

  ChatbotintentseditHandler = (row) => {
    this.setState({
      isEditing: true,
      show: true,
      chatbotintents_Id: row.chatbotintents_Id,
      intent_name: row.intent_name, intent_description: row.intent_description, training_phrases: row.training_phrases, response_templates: row.response_templates, required_parameters: row.required_parameters, chatbotactiontypemaster: [], action_type: row.action_type, target_page: row.target_page, api_endpoint: row.api_endpoint, requires_authentication: row.requires_authentication, confidence_threshold: row.confidence_threshold, usage_count: row.usage_count, success_rate: row.success_rate,
      //***editstate
      errors: {},
      touched: {}
    });
  }

  ChatbotintentsfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + 'C_Chatbotintents/list', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  }

  ChatbotintentssubmitHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before submitting", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append('intent_name', this.state.intent_name);
    formData.append('intent_description', this.state.intent_description);
    formData.append('training_phrases', this.state.training_phrases);
    formData.append('response_templates', this.state.response_templates);
    formData.append('required_parameters', this.state.required_parameters);
    formData.append('action_type', this.state.action_type);
    formData.append('target_page', this.state.target_page);
    formData.append('api_endpoint', this.state.api_endpoint);
    formData.append('requires_authentication', this.state.requires_authentication);
    formData.append('confidence_threshold', this.state.confidence_threshold);
    formData.append('usage_count', this.state.usage_count);
    formData.append('success_rate', this.state.success_rate);

    //***tableData*

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + 'C_Chatbotintents/add', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.ChatbotintentsfetchHandler();
          this.handleOffcanvasClose();
          this.setState({ intent_name: '', intent_description: '', training_phrases: '', response_templates: '', required_parameters: '', chatbotactiontypemaster: [], action_type: '', target_page: '', api_endpoint: '', requires_authentication: '', confidence_threshold: '', usage_count: '', success_rate: '', });
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      
        this.setState({ loading: false });});
  }

  ChatbotintentsupdateHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before updating", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("chatbotintents_Id", this.state.chatbotintents_Id);
    formData.append('intent_name', this.state.intent_name);
    formData.append('intent_description', this.state.intent_description);
    formData.append('training_phrases', this.state.training_phrases);
    formData.append('response_templates', this.state.response_templates);
    formData.append('required_parameters', this.state.required_parameters);
    formData.append('action_type', this.state.action_type);
    formData.append('target_page', this.state.target_page);
    formData.append('api_endpoint', this.state.api_endpoint);
    formData.append('requires_authentication', this.state.requires_authentication);
    formData.append('confidence_threshold', this.state.confidence_threshold);
    formData.append('usage_count', this.state.usage_count);
    formData.append('success_rate', this.state.success_rate);

    //***tableData1

    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + 'C_Chatbotintents/update', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.ChatbotintentsfetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Update error:", error);
        this.showToast("Failed to update data", "error");
      
        this.setState({ loading: false });});
  }

  componentDidMount() {
    this.ChatbotintentsfetchHandler();
    this.chatbotactiontypemasterfetchHandler();

    //***componentDidMount
  }

  handleintent_nameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ intent_name: fieldValue });
  }; handleintent_descriptionChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ intent_description: fieldValue });
  }; handletraining_phrasesChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ training_phrases: fieldValue });
  }; handleresponse_templatesChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ response_templates: fieldValue });
  }; handlerequired_parametersChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ required_parameters: fieldValue });
  }; handleaction_typeChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ action_type: fieldValue });
  }; chatbotactiontypemasterfetchHandler = () => {
    fetch(configData.api_url + "C_Chatbotactiontypemaster/list", {  // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}// body data type must match "Content-Type" header
    }).then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ chatbotactiontypemaster: data.list });
        }
      });
  }; handletarget_pageChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ target_page: fieldValue });
  }; handleapi_endpointChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ api_endpoint: fieldValue });
  }; handlerequires_authenticationChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ requires_authentication: fieldValue });
  }; handleconfidence_thresholdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ confidence_threshold: fieldValue });
  }; handleusage_countChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ usage_count: fieldValue });
  }; handlesuccess_rateChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ success_rate: fieldValue });
  };
  //***inputFunctions

  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row, index) => {
    if (!window.confirm(`Are you sure you want to delete this chatbotintents?`)) {
      return;
    }

    var formData = new FormData();
    formData.append('chatbotintents_Id', row.chatbotintents_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + 'C_Chatbotintents/delete', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.ChatbotintentsfetchHandler();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Delete error:", error);
        this.showToast("Failed to delete data", "error");
      
        this.setState({ loading: false });});
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  // Helper method to render error message
  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;
    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>
          {errors[fieldName]}
        </div>
      );
    }
    return null;
  };

  // Auto-generated form field renderer based on inputType and validation options
  renderFormField = (fieldConfig) => {
    const { fieldName, displayName, inputType, validationOptions } = fieldConfig;
    const value = this.state[fieldName] || "";
    const hasError = this.state.errors[fieldName] && this.state.touched[fieldName];

    let inputElement;

    switch (inputType.toLowerCase()) {
      case 'dob_child':
      case 'dob_adult':
      case 'date':
        inputElement = (
          <Form.Control
            type="date"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
          />
        );
        break;

      case 'telephone':
      case 'phone':
        inputElement = (
          <Form.Control
            type="tel"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter 10-digit mobile number"
          />
        );
        break;

      case 'mail':
      case 'email':
        inputElement = (
          <Form.Control
            type="email"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter email address"
          />
        );
        break;

      case 'password':
        inputElement = (
          <Form.Control
            type="password"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter password"
          />
        );
        break;

      case 'number':
        inputElement = (
          <Form.Control
            type="number"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
          />
        );
        break;

      case 'pan':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.toUpperCase(), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="ABCPA1234B"
            maxLength="10"
          />
        );
        break;

      case 'aadhaar':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.replace(/\D/g, ''), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="123456789012"
            maxLength="12"
          />
        );
        break;

      default: // text and other types
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
            maxLength={validationOptions?.maxLength || undefined}
          />
        );
    }

    return (
      <Row key={fieldName}>
        <Col lg="4" md="4">
          <Form.Label>
            {displayName}
            {validationOptions?.isRequired && <span className="text-danger">*</span>}
          </Form.Label>
        </Col>
        <Col lg="8" md="8">
          {inputElement}
          {this.renderFieldError(fieldName)}
        </Col>
      </Row>
    );
  };

  render() {
    const { errors, touched } = this.state;

    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>Chatbot Intents</h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary" style={{ float: "right", marginBottom: "10px" }}
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>

                      {/* Enhanced Add Offcanvas */}
                      <Offcanvas
                        show={this.state.show && !this.state.isEditing}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Add Chatbotintents</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container style={{ "overflowY": "auto", height: "auto" }}>

                            {/* Error Summary */}
                            {Object.keys(errors).length > 0 && (
                              <div className="alert alert-danger mb-3">
                                <strong>Please fix the following errors:</strong>
                                <ul className="mb-0 mt-2">
                                  {Object.entries(errors).map(([field, error]) => (
                                    <li key={field}>{error}</li>
                                  ))}
                                </ul>
                              </div>
                            )}

                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Intent Name</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleintent_nameChange} className="form-control" name="intent_name" value={this.state.intent_name} required="required" placeholder="Enter Intent Name" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.intent_name} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Intent Description</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleintent_descriptionChange} className="form-control" name="intent_description" value={this.state.intent_description} required="required" placeholder="Enter Intent Description" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.intent_description} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Training Phrases</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletraining_phrasesChange} className="form-control" name="training_phrases" value={this.state.training_phrases} required="required" placeholder="Enter Training Phrases" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.training_phrases} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Response Templates</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleresponse_templatesChange} className="form-control" name="response_templates" value={this.state.response_templates} required="required" placeholder="Enter Response Templates" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.response_templates} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Required Parameters</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlerequired_parametersChange} className="form-control" name="required_parameters" value={this.state.required_parameters} required="required" placeholder="Enter Required Parameters" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.required_parameters} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Action Type</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <select className="form-select" name="tableName" onChange={this.handleaction_typeChange}>
                                        <option defaultValue> Select Action Type </option>
                                        {this.state.chatbotactiontypemaster.map((api, index, idx) => (
                                          <option key={index} value={api.navigation}> {api.navigation} </option>
                                        ))}
                                      </select>
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.action_type} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Target Page</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletarget_pageChange} className="form-control" name="target_page" value={this.state.target_page} required="required" placeholder="Enter Target Page" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.target_page} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Api Endpoint</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleapi_endpointChange} className="form-control" name="api_endpoint" value={this.state.api_endpoint} required="required" placeholder="Enter Api Endpoint" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.api_endpoint} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Requires Authentication</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlerequires_authenticationChange} className="form-control" name="requires_authentication" value={this.state.requires_authentication} required="required" placeholder="Enter Requires Authentication" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.requires_authentication} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Confidence Threshold</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleconfidence_thresholdChange} className="form-control" name="confidence_threshold" value={this.state.confidence_threshold} required="required" placeholder="Enter Confidence Threshold" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.confidence_threshold} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Usage Count</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handleusage_countChange} className="form-control" name="usage_count" value={this.state.usage_count} required="required" placeholder="Enter Usage Count" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.usage_count} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Success Rate</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlesuccess_rateChange} className="form-control" name="success_rate" value={this.state.success_rate} required="required" placeholder="Enter Success Rate" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.success_rate} </div>
                                  </Row><br />
                                  {/* Auto-generated form content with validation */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.ChatbotintentssubmitHandler}
                                  disabled={!this.isFormValid()}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {/* Enhanced Edit Offcanvas */}
                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit Chatbotintents</Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container style={{ "overflowY": "auto", height: "auto" }}>

                              {/* Error Summary */}
                              {Object.keys(errors).length > 0 && (
                                <div className="alert alert-danger mb-3">
                                  <strong>Please fix the following errors:</strong>
                                  <ul className="mb-0 mt-2">
                                    {Object.entries(errors).map(([field, error]) => (
                                      <li key={field}>{error}</li>
                                    ))}
                                  </ul>
                                </div>
                              )}

                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Intent Name</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleintent_nameChange} className="form-control" name="intent_name" value={this.state.intent_name} required="required" placeholder="Enter Intent Name" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.intent_name} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Intent Description</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleintent_descriptionChange} className="form-control" name="intent_description" value={this.state.intent_description} required="required" placeholder="Enter Intent Description" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.intent_description} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Training Phrases</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletraining_phrasesChange} className="form-control" name="training_phrases" value={this.state.training_phrases} required="required" placeholder="Enter Training Phrases" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.training_phrases} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Response Templates</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleresponse_templatesChange} className="form-control" name="response_templates" value={this.state.response_templates} required="required" placeholder="Enter Response Templates" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.response_templates} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Required Parameters</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlerequired_parametersChange} className="form-control" name="required_parameters" value={this.state.required_parameters} required="required" placeholder="Enter Required Parameters" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.required_parameters} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Action Type</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <select className="form-select" name="tableName" onChange={this.handleaction_typeChange}>
                                          <option defaultValue> Select Action Type </option>
                                          {this.state.chatbotactiontypemaster.map((api, index, idx) => (
                                            <option key={index} value={api.navigation}> {api.navigation} </option>
                                          ))}
                                        </select>
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.action_type} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Target Page</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletarget_pageChange} className="form-control" name="target_page" value={this.state.target_page} required="required" placeholder="Enter Target Page" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.target_page} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Api Endpoint</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleapi_endpointChange} className="form-control" name="api_endpoint" value={this.state.api_endpoint} required="required" placeholder="Enter Api Endpoint" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.api_endpoint} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Requires Authentication</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlerequires_authenticationChange} className="form-control" name="requires_authentication" value={this.state.requires_authentication} required="required" placeholder="Enter Requires Authentication" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.requires_authentication} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Confidence Threshold</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleconfidence_thresholdChange} className="form-control" name="confidence_threshold" value={this.state.confidence_threshold} required="required" placeholder="Enter Confidence Threshold" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.confidence_threshold} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Usage Count</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handleusage_countChange} className="form-control" name="usage_count" value={this.state.usage_count} required="required" placeholder="Enter Usage Count" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.usage_count} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Success Rate</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlesuccess_rateChange} className="form-control" name="success_rate" value={this.state.success_rate} required="required" placeholder="Enter Success Rate" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.success_rate} </div>
                                    </Row><br />
                                    {/* Auto-generated form content with validation */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.ChatbotintentsupdateHandler}
                                    disabled={!this.isFormValid()}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ "marginRight": "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}